import { render, staticRenderFns } from "./AssistantView.vue?vue&type=template&id=601fe26c&scoped=true"
var script = {}
import style0 from "./AssistantView.vue?vue&type=style&index=0&id=601fe26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601fe26c",
  null
  
)

export default component.exports